module.exports = "https://cdn-skillquest.mathletics.com/app/168/assets/images/b246a759f3580664dc26c998995decee.svg";